/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React, { useState } from 'react';
import {
  OuiDragDropContext,
  OuiDraggable,
  OuiDroppable,
  OuiFlexGroup,
  OuiFlexItem,
  OuiIcon,
  OuiPanel,
  ouiDragDropReorder,
} from '../../../../src/components';
import { htmlIdGenerator } from '../../../../src/services';

const makeId = htmlIdGenerator();

const makeList = (number, start = 1) =>
  Array.from({ length: number }, (v, k) => k + start).map((el) => {
    return {
      content: `Item ${el}`,
      id: makeId(),
    };
  });

export default () => {
  const [list, setList] = useState(makeList(3));
  const onDragEnd = ({ source, destination }) => {
    if (source && destination) {
      const items = ouiDragDropReorder(list, source.index, destination.index);

      setList(items);
    }
  };
  return (
    <OuiDragDropContext onDragEnd={onDragEnd}>
      <OuiDroppable
        droppableId="CUSTOM_HANDLE_DROPPABLE_AREA"
        spacing="m"
        withPanel>
        {list.map(({ content, id }, idx) => (
          <OuiDraggable
            spacing="m"
            key={id}
            index={idx}
            draggableId={id}
            customDragHandle={true}>
            {(provided) => (
              <OuiPanel className="custom" paddingSize="m">
                <OuiFlexGroup>
                  <OuiFlexItem grow={false}>
                    <div {...provided.dragHandleProps} aria-label="Drag Handle">
                      <OuiIcon type="grab" />
                    </div>
                  </OuiFlexItem>
                  <OuiFlexItem>{content}</OuiFlexItem>
                </OuiFlexGroup>
              </OuiPanel>
            )}
          </OuiDraggable>
        ))}
      </OuiDroppable>
    </OuiDragDropContext>
  );
};
